import React from 'react';
import { Toaster as GuiToaster, toast } from '@oliasoft-open-source/react-ui-library';
import { NotificationTypes } from '../../constants';

const typeMap = {
  [NotificationTypes.DEFAULT]: 'Info',
  [NotificationTypes.SUCCESS]: 'Success',
  [NotificationTypes.WARNING]: 'Warning',
  [NotificationTypes.ERROR]: 'Error',
};

const show = ({ type = NotificationTypes.DEFAULT, message, title, details, timeout, onClose }, key) =>
  toast({
    id: key,
    message: {
      type: typeMap[type] || type,
      heading: title,
      content: message,
      details,
    },
    autoClose: timeout,
    onClose,
  });

/**
 * @typedef {{
 *   type?: string,
 *   message?: import('react').ReactNode,
 *   title?: string | number,
 *   details?: import('react').ReactNode,
 *   timeout?: number | false,
 *   onClose?: () => void,
 * }} ToastShowOptions
 */

/**
 * Keep the old local notification API while using the shared GUI toaster.
 *
 * @type {import('react').ComponentType<Record<string, unknown>> & {
 *   show: (options: ToastShowOptions, key?: string | number) => unknown,
 * }}
 */
const Toaster = Object.assign((props) => React.createElement(GuiToaster, { limit: 5, ...props }), {
  show,
});

export default Toaster;
export { Toaster };
